import { Component, Input } from "@angular/core";

@Component({
  selector: "ngx-pro-plan-label",
  templateUrl: "pro-plan-label.component.html",
  styleUrls: ["pro-plan-label.component.scss"],
})
export class ProPlanLabelComponent {
  constructor() { }
  
  @Input() source: string = ''
  @Input() icon: boolean = false

  upgradeToPro() {
    document.dispatchEvent(new CustomEvent('open-dialog', { detail: { id: 'purchase-subscription', source: this.source } }));
  }
}
